// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Common = require("../utils/Common.res.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var MM_parser = require("./MM_parser.res.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.res.js");
var MM_parenCounter_unoptimized = require("./MM_parenCounter_unoptimized.res.js");

function exprEq(a, b) {
  var len1 = a.length;
  var len2 = b.length;
  if (len1 !== len2) {
    return false;
  }
  var eq = true;
  var i = 0;
  while(eq && i < len1) {
    eq = a[i] === b[i];
    i = i + 1 | 0;
  };
  return eq;
}

function exprCmp(e1, e2) {
  var len1 = e1.length;
  var len2 = e2.length;
  var r = Caml.int_compare(len1, len2);
  if (r !== 0.0) {
    return r;
  }
  var res = 0.0;
  var i = 0;
  while(i < len1 && res === 0.0) {
    res = Caml.int_compare(e1[i], e2[i]);
    i = i + 1 | 0;
  };
  return res;
}

var cmp = Expln_utils_common.toIntCmp(exprCmp);

var ExprCmp = Belt_Id.MakeComparableU({
      cmp: cmp
    });

var ExprHash = Belt_Id.MakeHashableU({
      hash: Expln_utils_common.hashArrInt,
      eq: exprEq
    });

function disjAddPair(disjMap, n, m) {
  if (n === m) {
    return ;
  }
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var set = Belt_HashMapInt.get(disjMap, min);
  if (set !== undefined) {
    return Belt_HashSetInt.add(Caml_option.valFromOption(set), max);
  } else {
    return Belt_HashMapInt.set(disjMap, min, Belt_HashSetInt.fromArray([max]));
  }
}

function disjMutToDisjImm(disj) {
  return Belt_MapInt.fromArray(Belt_HashMapInt.toArray(disj).map(function (param) {
                  return [
                          param[0],
                          Belt_SetInt.fromArray(Belt_HashSetInt.toArray(param[1]))
                        ];
                }));
}

function forEachCtxInDeclarationOrder(ctx, consumer) {
  var parent = ctx.parent;
  if (parent === undefined) {
    return consumer(ctx);
  }
  var res = forEachCtxInDeclarationOrder(parent, consumer);
  if (res !== undefined) {
    return Caml_option.some(Caml_option.valFromOption(res));
  } else {
    return consumer(ctx);
  }
}

function forEachCtxInReverseOrder(_ctx, consumer) {
  while(true) {
    var ctx = _ctx;
    var res = consumer(ctx);
    if (res !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(res));
    }
    var parent = ctx.parent;
    if (parent === undefined) {
      return ;
    }
    _ctx = parent;
    continue ;
  };
}

function isDebug(ctx) {
  return ctx.contents.debug;
}

function getTokenType(ctx, token) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                var frame = Belt_HashMapString.get(ctx.frames, token);
                if (frame !== undefined) {
                  if (frame.isAxiom) {
                    return "A";
                  } else {
                    return "P";
                  }
                }
                var hyp = Belt_HashMapString.get(ctx.labelToHyp, token);
                if (hyp !== undefined) {
                  if (hyp.typ === "F") {
                    return "F";
                  } else {
                    return "E";
                  }
                }
                var i = Belt_HashMapString.get(ctx.symToInt, token);
                if (i !== undefined) {
                  if (i < 0) {
                    return "C";
                  } else {
                    return "V";
                  }
                }
                
              }));
}

function isConst(ctx, sym) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_HashMapString.get(Belt_Option.getExn(ctx.contents.root).symToInt, sym), (function (i) {
                    return i < 0;
                  })), false);
}

function isVar(ctx, sym) {
  return Belt_Option.getWithDefault(Belt_Option.map(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                        return Belt_HashMapString.get(ctx.symToInt, sym);
                      })), (function (i) {
                    return 0 <= i;
                  })), false);
}

function isHyp(ctx, label) {
  return Belt_Option.isSome(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    return Belt_HashMapString.get(ctx.labelToHyp, label);
                  })));
}

function isAsrt(ctx, label) {
  return Belt_Option.isSome(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    return Belt_HashMapString.get(ctx.frames, label);
                  })));
}

function disjContains(disj, n, m) {
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var ms = Belt_HashMapInt.get(disj, min);
  if (ms !== undefined) {
    return Belt_HashSetInt.has(Caml_option.valFromOption(ms), max);
  } else {
    return false;
  }
}

function disjImmContains(disj, n, m) {
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var ms = Belt_MapInt.get(disj, min);
  if (ms !== undefined) {
    return Belt_SetInt.has(Caml_option.valFromOption(ms), max);
  } else {
    return false;
  }
}

function disjForEach(disjMutable, consumer) {
  Belt_HashMapInt.forEach(disjMutable, (function (n, ms) {
          Belt_HashSetInt.forEach(ms, (function (m) {
                  consumer(n, m);
                }));
        }));
}

function disjForEachOrdered(disjMutable, consumer) {
  var ns = Belt_HashMapInt.keysToArray(disjMutable);
  ns.sort(Caml.int_compare);
  ns.forEach(function (n) {
        var ms = Belt_HashSetInt.toArray(Core__Option.getExn(Belt_HashMapInt.get(disjMutable, n), undefined));
        ms.sort(Caml.int_compare);
        ms.forEach(function (m) {
              consumer(n, m);
            });
      });
}

function disjImmForEach(disj, consumer) {
  Belt_MapInt.forEach(disj, (function (n, ms) {
          Belt_SetInt.forEach(ms, (function (m) {
                  consumer(n, m);
                }));
        }));
}

function disjGetAllVars(disj) {
  var res = Belt_HashSetInt.make(100);
  Belt_HashMapInt.forEach(disj, (function (n, ms) {
          Belt_HashSetInt.add(res, n);
          Belt_HashSetInt.forEach(ms, (function (m) {
                  Belt_HashSetInt.add(res, m);
                }));
        }));
  return res;
}

function disjToArr(disj, sortByTypeAndNameOpt, varIntToVarName, varIntToVarType, typeOrder) {
  var sortByTypeAndName = sortByTypeAndNameOpt !== undefined ? sortByTypeAndNameOpt : false;
  var res = [];
  disjForEachOrdered(disj, (function (n, m) {
          res.push([
                n,
                m
              ]);
        }));
  var canMerge = function (d1, d2) {
    var canMerge$1 = {
      contents: true
    };
    d1.forEach(function (v1) {
          if (canMerge$1.contents) {
            d2.forEach(function (v2) {
                  if (canMerge$1.contents && v1 !== v2) {
                    canMerge$1.contents = disjContains(disj, v1, v2);
                    return ;
                  }
                  
                });
            return ;
          }
          
        });
    return canMerge$1.contents;
  };
  var merge = function (d1, d2) {
    res.splice(res.findIndex(function (d) {
              return exprEq(d, d2);
            }), 1);
    d2.forEach(function (v2) {
          if (!d1.includes(v2)) {
            d1.push(v2);
            return ;
          }
          
        });
  };
  var findWhatToMerge = function () {
    var found;
    for(var i = 0 ,i_finish = res.length - 2 | 0; i <= i_finish; ++i){
      if (Belt_Option.isNone(found)) {
        for(var j = i + 1 | 0 ,j_finish = res.length; j < j_finish; ++j){
          if (Belt_Option.isNone(found)) {
            var d1 = res[i];
            var d2 = res[j];
            if (canMerge(d1, d2)) {
              found = [
                d1,
                d2
              ];
            }
            
          }
          
        }
      }
      
    }
    return found;
  };
  var mergeFound = true;
  while(mergeFound) {
    var match = findWhatToMerge();
    if (match !== undefined) {
      merge(match[0], match[1]);
    } else {
      mergeFound = false;
    }
  };
  var sortBy;
  if (sortByTypeAndName) {
    if (varIntToVarType !== undefined) {
      if (typeOrder !== undefined) {
        if (varIntToVarName !== undefined) {
          var allDisjVars = disjGetAllVars(disj);
          var allDisjVarTypes = Belt_HashMapInt.make(Belt_HashSetInt.size(allDisjVars));
          var allDisjVarNames = Belt_HashMapInt.make(Belt_HashSetInt.size(allDisjVars));
          Belt_HashSetInt.forEach(allDisjVars, (function (i) {
                  var typ = varIntToVarType(i);
                  if (typ !== undefined) {
                    Belt_HashMapInt.set(allDisjVarTypes, i, typ);
                  }
                  var str = varIntToVarName(i);
                  if (str !== undefined) {
                    return Belt_HashMapInt.set(allDisjVarNames, i, str);
                  }
                  
                }));
          var varTypeCmp = Common.createVarTypeComparator(allDisjVarTypes, Caml_option.valFromOption(typeOrder));
          var varNameCmp = Common.createVarNameComparator(allDisjVarNames);
          sortBy = Expln_utils_common.comparatorAndThen(varTypeCmp, varNameCmp);
        } else {
          sortBy = Caml.int_compare;
        }
      } else {
        sortBy = Caml.int_compare;
      }
    } else {
      sortBy = Caml.int_compare;
    }
  } else {
    sortBy = Caml.int_compare;
  }
  res.forEach(function (d) {
        Expln_utils_common.sortInPlaceWith(d, sortBy);
      });
  return Expln_utils_common.sortInPlaceWith(res, exprCmp);
}

function disjForEachArr(disj, sortByTypeAndNameOpt, varIntToVarName, varIntToVarType, typeOrder, consumer) {
  var sortByTypeAndName = sortByTypeAndNameOpt !== undefined ? sortByTypeAndNameOpt : false;
  disjToArr(disj, sortByTypeAndName, varIntToVarName, varIntToVarType, typeOrder).forEach(consumer);
}

function disjIsEmpty(disjMutable) {
  return Belt_HashMapInt.size(disjMutable) === 0;
}

function isDisj(ctx, n, m) {
  return Belt_Option.getWithDefault(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    if (disjContains(ctx.disj, n, m)) {
                      return true;
                    }
                    
                  })), false);
}

function getHypothesis(ctx, label) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapString.get(ctx.labelToHyp, label);
              }));
}

function exprToHypAdd(ctx, hyp) {
  var expr = hyp.expr;
  var len = expr.length;
  var fstSym = len > 0 ? expr[0] : 0;
  var sndSym = len > 1 ? expr[1] : 0;
  var fstSymToHyp = Belt_HashMapInt.get(ctx.exprToHyp, len);
  if (fstSymToHyp === undefined) {
    return Belt_HashMapInt.set(ctx.exprToHyp, len, Belt_HashMapInt.fromArray([[
                      fstSym,
                      Belt_HashMapInt.fromArray([[
                              sndSym,
                              [hyp]
                            ]])
                    ]]));
  }
  var fstSymToHyp$1 = Caml_option.valFromOption(fstSymToHyp);
  var sndSymToHyp = Belt_HashMapInt.get(fstSymToHyp$1, fstSym);
  if (sndSymToHyp === undefined) {
    return Belt_HashMapInt.set(fstSymToHyp$1, fstSym, Belt_HashMapInt.fromArray([[
                      sndSym,
                      [hyp]
                    ]]));
  }
  var sndSymToHyp$1 = Caml_option.valFromOption(sndSymToHyp);
  var hypsArr = Belt_HashMapInt.get(sndSymToHyp$1, sndSym);
  if (hypsArr === undefined) {
    return Belt_HashMapInt.set(sndSymToHyp$1, sndSym, [hyp]);
  }
  var match = hypsArr.find(function (h) {
        return exprEq(h.expr, hyp.expr);
      });
  if (match !== undefined) {
    return ;
  } else {
    hypsArr.push(hyp);
    return ;
  }
}

function getHypByExpr(ctx, expr) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                var len = expr.length;
                var fstSymToHyp = Belt_HashMapInt.get(ctx.exprToHyp, len);
                if (fstSymToHyp === undefined) {
                  return ;
                }
                var fstSym = len > 0 ? expr[0] : 0;
                var sndSymToHyp = Belt_HashMapInt.get(Caml_option.valFromOption(fstSymToHyp), fstSym);
                if (sndSymToHyp === undefined) {
                  return ;
                }
                var sndSym = len > 1 ? expr[1] : 0;
                var hypsArr = Belt_HashMapInt.get(Caml_option.valFromOption(sndSymToHyp), sndSym);
                if (hypsArr !== undefined) {
                  return hypsArr.find(function (h) {
                              return exprEq(h.expr, expr);
                            });
                }
                
              }));
}

function getFrame(ctx, label) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapString.get(ctx.frames, label);
              }));
}

function getFrameExn(ctx, label) {
  var frame = getFrame(ctx, label);
  if (frame !== undefined) {
    return frame;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Could not find a frame by the label '" + label + "'"
        },
        Error: new Error()
      };
}

function frameIsAllowed(frame, frameRestrict) {
  if ((!frame.isDisc || frameRestrict.useDisc) && (!frame.isDepr || frameRestrict.useDepr)) {
    if (frame.isTranDepr) {
      return frameRestrict.useTranDepr;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function getLocalVars(ctx) {
  return ctx.contents.vars.slice();
}

function getLocalHyps(ctx) {
  return ctx.contents.hyps.slice();
}

function getNumOfVars(ctx) {
  return ctx.contents.varsBaseIdx + ctx.contents.vars.length | 0;
}

function forEachHypothesisInDeclarationOrder(ctx, consumer) {
  return forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
                return Expln_utils_common.arrForEach(ctx.hyps, consumer);
              }));
}

function ctxSymToInt(ctx, sym) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapString.get(ctx.symToInt, sym);
              }));
}

function ctxSymToIntExn(ctx, sym) {
  var i = ctxSymToInt(ctx, sym);
  if (i !== undefined) {
    return i;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "The symbol '" + sym + "' is not declared."
        },
        Error: new Error()
      };
}

function ctxSymsToIntsExn(ctx, symbols) {
  return symbols.map(function (__x) {
              return ctxSymToIntExn(ctx, __x);
            });
}

function ctxStrToIntsExn(ctx, str) {
  return ctxSymsToIntsExn(ctx, Common.getSpaceSeparatedValuesAsArray(str));
}

function ctxIntToSym(ctx, i) {
  if (i < 0) {
    return Belt_Array.get(Belt_Option.getExn(ctx.contents.root).consts, -i | 0);
  } else {
    return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                  if (i < ctx.varsBaseIdx) {
                    return ;
                  } else {
                    return ctx.vars[i - ctx.varsBaseIdx | 0];
                  }
                }));
  }
}

function ctxIntToSymExn(ctx, i) {
  var str = ctxIntToSym(ctx, i);
  if (str !== undefined) {
    return str;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot convert " + String(i) + " to a symbol."
        },
        Error: new Error()
      };
}

function ctxIntsToSymsExn(ctx, expr) {
  return expr.map(function (__x) {
              return ctxIntToSymExn(ctx, __x);
            });
}

function ctxIntsToStrExn(ctx, expr) {
  return expr.map(function (__x) {
                return ctxIntToSymExn(ctx, __x);
              }).join(" ");
}

function disjToStrDbg(disj, ctx) {
  var res = [];
  Belt_HashMapInt.keysToArray(disj).toSorted(Caml.int_compare).forEach(function (n) {
        var ms = Core__Option.getExn(Belt_HashMapInt.get(disj, n), undefined);
        res.push(ctxIntToSymExn(ctx, n) + " -> " + ctxIntsToStrExn(ctx, Belt_HashSetInt.toArray(ms).toSorted(Caml.int_compare)));
      });
  return res.join("\n");
}

function frmIntToSym(ctx, frame, i) {
  if (i < 0) {
    return ctxIntToSym(ctx, i);
  } else {
    return Belt_Array.get(frame.frameVarToSymb, i);
  }
}

function frmIntToSymExn(ctx, frame, i) {
  var sym = frmIntToSym(ctx, frame, i);
  if (sym !== undefined) {
    return sym;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Could not convert from int " + String(i) + " to a symbol."
        },
        Error: new Error()
      };
}

function frmIntsToSymsExn(ctx, frame, expr) {
  return expr.map(function (__x) {
              return frmIntToSymExn(ctx, frame, __x);
            });
}

function frmIntsToStrExn(ctx, frame, expr) {
  return frmIntsToSymsExn(ctx, frame, expr).join(" ");
}

function getTypeOfVar(ctx, varInt) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapInt.get(ctx.varTypes, varInt);
              }));
}

function getTypeOfVarExn(ctx, varInt) {
  var typ = getTypeOfVar(ctx, varInt);
  if (typ !== undefined) {
    return typ;
  }
  var sym = ctxIntToSym(ctx, varInt);
  var varName = sym !== undefined ? "'" + sym + "'" : String(varInt);
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot determine type of the variable " + varName
        },
        Error: new Error()
      };
}

function extractMandatoryVariables(ctx, asrt, skipEssentialsOpt, overrideHyps) {
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var res = Belt_HashSetInt.make(16);
  if (!skipEssentials) {
    if (overrideHyps !== undefined) {
      overrideHyps.forEach(function (hypExpr) {
            hypExpr.forEach(function (i) {
                  if (i >= 0) {
                    return Belt_HashSetInt.add(res, i);
                  }
                  
                });
          });
    } else {
      forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
              if (hyp.typ === "E") {
                hyp.expr.forEach(function (i) {
                      if (i >= 0) {
                        return Belt_HashSetInt.add(res, i);
                      }
                      
                    });
              }
              
            }));
    }
  }
  asrt.forEach(function (i) {
        if (i >= 0) {
          return Belt_HashSetInt.add(res, i);
        }
        
      });
  return res;
}

function extractMandatoryDisj(ctx, mandatoryVars) {
  var mandatoryDisj = Belt_HashMapInt.make(16);
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapInt.forEach(ctx.disj, (function (n, ms) {
                  if (Belt_HashSetInt.has(mandatoryVars, n)) {
                    return Belt_HashSetInt.forEach(ms, (function (m) {
                                  if (Belt_HashSetInt.has(mandatoryVars, m)) {
                                    return disjAddPair(mandatoryDisj, n, m);
                                  }
                                  
                                }));
                  }
                  
                }));
        }));
  return mandatoryDisj;
}

function extractMandatoryHypotheses(ctx, mandatoryVars, skipEssentialsOpt, overrideHyps) {
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var res = [];
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          if (hyp.typ === "E" && !skipEssentials && Belt_Option.isNone(overrideHyps) || hyp.typ === "F" && Belt_HashSetInt.has(mandatoryVars, hyp.expr[1])) {
            res.push(hyp);
          }
          
        }));
  if (overrideHyps !== undefined) {
    overrideHyps.forEach(function (hypExpr, i) {
          res.push({
                typ: "E",
                label: String(i),
                expr: hypExpr
              });
        });
  }
  return res;
}

function getAllConsts(ctx) {
  return Belt_Option.getExn(ctx.contents.root).consts.slice(1);
}

function getMandHyps(ctx, expr, skipEssentialsOpt, overrideHyps) {
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var mandatoryVars = extractMandatoryVariables(ctx, expr, skipEssentials, overrideHyps);
  return extractMandatoryHypotheses(ctx, mandatoryVars, skipEssentials, overrideHyps);
}

function getAllHyps(ctx) {
  var hyps = [];
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          hyps.push(hyp);
        }));
  return Belt_MapString.fromArray(hyps.map(function (hyp) {
                  return [
                          hyp.label,
                          hyp
                        ];
                }));
}

function getAllFramesArr(ctx) {
  var frames = [];
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Caml_splice_call.spliceObjApply(frames, "push", [Belt_HashMapString.valuesToArray(ctx.frames)]);
        }));
  return frames;
}

function getAllFrames(ctx) {
  var frames = [];
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapString.forEach(ctx.frames, (function (k, v) {
                  frames.push([
                        k,
                        v
                      ]);
                }));
        }));
  return Belt_MapString.fromArray(frames);
}

function forEachFrame(ctx, consumer) {
  return forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
                var result = {
                  contents: undefined
                };
                Belt_HashMapString.forEach(ctx.frames, (function (param, frm) {
                        if (Belt_Option.isNone(result.contents)) {
                          result.contents = consumer(frm);
                          return ;
                        }
                        
                      }));
                return result.contents;
              }));
}

function getNestingLevelPriv(ctx) {
  var pCtx = ctx.parent;
  if (pCtx !== undefined) {
    return 1 + getNestingLevelPriv(pCtx) | 0;
  } else {
    return 0;
  }
}

function getNestingLevel(ctx) {
  return getNestingLevelPriv(ctx.contents);
}

function findParentheses(ctx, onProgress) {
  var getAllExprs = function (ctx) {
    var allExpr = [];
    forEachFrame(ctx, (function (frame) {
            frame.hyps.forEach(function (hyp) {
                  if (hyp.typ === "E") {
                    allExpr.push(hyp.expr);
                    return ;
                  }
                  
                });
            allExpr.push(frame.asrt);
          }));
    return allExpr;
  };
  var checkValidParens = function (allExprs, openSym, closeSym) {
    var res = true;
    var openUsed = false;
    var closeUsed = false;
    var parenCnt = MM_parenCounter_unoptimized.parenCntMake([
          openSym,
          closeSym
        ], false);
    var parenState = "Balanced";
    var allExprsLen = allExprs.length;
    var e = 0;
    while(e < allExprsLen && res) {
      var expr = allExprs[e];
      var exprLen = expr.length;
      var s = 0;
      while(s < exprLen && res) {
        var sym = expr[s];
        if (!openUsed && sym === openSym) {
          openUsed = true;
        }
        if (!closeUsed && sym === closeSym) {
          closeUsed = true;
        }
        parenState = MM_parenCounter_unoptimized.parenCntPut(parenCnt, sym);
        res = parenState !== "Failed";
        s = s + 1 | 0;
      };
      res = parenState === "Balanced";
      e = e + 1 | 0;
    };
    if (res && openUsed) {
      return closeUsed;
    } else {
      return false;
    }
  };
  var allExprs = getAllExprs(ctx);
  var allConsts = (function (__x) {
          return ctxSymsToIntsExn(ctx, __x);
        })(Common.getSpaceSeparatedValuesAsArray("( ) [ ] { } [. ]. [_ ]_ <. >. <\" \"> << >> [s ]s (. ). (( ))").filter(function (__x) {
              return isConst(ctx, __x);
            })).concat(Belt_Array.range(1, Belt_Option.getExn(ctx.contents.root).consts.length - 1 | 0).map(function (i) {
            return -i | 0;
          }));
  var maxC = allConsts.length - 2 | 0;
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined);
  var foundParens = [];
  for(var c = 0; c <= maxC; ++c){
    var openParen = allConsts[c];
    var closeParen = allConsts[c + 1 | 0];
    if (!foundParens.includes(openParen) && !foundParens.includes(closeParen) && checkValidParens(allExprs, openParen, closeParen)) {
      foundParens.push(openParen);
      foundParens.push(closeParen);
    }
    MM_progress_tracker.progressTrackerSetCurrPct(progressState, c / maxC);
  }
  return foundParens;
}

function disjMake() {
  return Belt_HashMapInt.make(16);
}

function getAllDisj(ctx) {
  var disj = Belt_HashMapInt.make(16);
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapInt.forEach(ctx.disj, (function (n, ms) {
                  Belt_HashSetInt.forEach(ms, (function (m) {
                          disjAddPair(disj, n, m);
                        }));
                }));
        }));
  return disj;
}

function getLocalDisj(ctx) {
  var disj = Belt_HashMapInt.make(16);
  Belt_HashMapInt.forEach(ctx.contents.disj, (function (n, ms) {
          Belt_HashSetInt.forEach(ms, (function (m) {
                  disjAddPair(disj, n, m);
                }));
        }));
  return disj;
}

function createContext(parent, debugOpt) {
  var debug = debugOpt !== undefined ? debugOpt : false;
  var pCtxContentsOpt = parent !== undefined ? (parent.contents.lastComment = undefined, parent.contents) : undefined;
  var ctx = {
    contents: {
      root: undefined,
      parent: pCtxContentsOpt,
      consts: pCtxContentsOpt !== undefined ? [] : [""],
      varsBaseIdx: pCtxContentsOpt !== undefined ? pCtxContentsOpt.varsBaseIdx + pCtxContentsOpt.vars.length | 0 : 0,
      vars: [],
      symToInt: Belt_HashMapString.make(0),
      disj: Belt_HashMapInt.make(16),
      hyps: [],
      labelToHyp: Belt_HashMapString.make(4),
      exprToHyp: Belt_HashMapInt.make(4),
      varTypes: Belt_HashMapInt.make(4),
      lastComment: undefined,
      frames: Belt_HashMapString.make(1),
      totalNumOfFrames: pCtxContentsOpt !== undefined ? pCtxContentsOpt.totalNumOfFrames : 0,
      deprOrTranDeprFrms: Belt_HashSetString.make(1),
      debug: Belt_Option.getWithDefault(Belt_Option.map(pCtxContentsOpt, (function (pCtx) {
                  return pCtx.debug;
                })), debug)
    }
  };
  if (pCtxContentsOpt !== undefined) {
    ctx.contents.root = pCtxContentsOpt.root;
  } else {
    ctx.contents.root = ctx.contents;
  }
  return ctx;
}

function openChildContext(ctx) {
  ctx.contents = createContext(ctx, undefined).contents;
}

function closeChildContext(ctx) {
  var childCtx = ctx.contents;
  var parent = childCtx.parent;
  var tmp;
  if (parent !== undefined) {
    parent.lastComment = undefined;
    parent.totalNumOfFrames = parent.totalNumOfFrames + Belt_HashMapString.size(childCtx.frames) | 0;
    Belt_HashMapString.forEach(childCtx.frames, (function (k, v) {
            Belt_HashMapString.set(parent.frames, k, v);
          }));
    var partial_arg = parent.deprOrTranDeprFrms;
    Belt_HashSetString.forEach(childCtx.deprOrTranDeprFrms, (function (param) {
            return Belt_HashSetString.add(partial_arg, param);
          }));
    tmp = parent;
  } else {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot close the root context."
          },
          Error: new Error()
        };
  }
  ctx.contents = tmp;
}

function resetToParentContext(ctx) {
  var parent = ctx.contents.parent;
  var tmp;
  if (parent !== undefined) {
    parent.lastComment = undefined;
    tmp = parent;
  } else {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot reset the root context."
          },
          Error: new Error()
        };
  }
  ctx.contents = tmp;
}

function addComment(ctx, str) {
  ctx.contents.lastComment = str;
}

function assertNameIsUnique(ctx, name, tokenType) {
  if (name.trim() === "") {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot use an empty string as a name of " + tokenType + "."
          },
          Error: new Error()
        };
  }
  var match = getTokenType(ctx, name);
  if (match === undefined) {
    return ;
  }
  switch (match) {
    case "C" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "An attempt to re-declare the constant '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case "V" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "An attempt to re-declare the variable '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case "F" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "An attempt to re-declare a floating label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case "E" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "An attempt to re-declare an essential label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case "A" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "An attempt to re-declare an axiom label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case "P" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "An attempt to re-declare a provable label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    
  }
}

function addDisj(ctx, vars) {
  var sym = vars.find(function (sym) {
        return !isVar(ctx, sym);
      });
  if (sym !== undefined) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "The symbol '" + sym + "' is not a variable but it is used in a disjoint statement."
          },
          Error: new Error()
        };
  }
  var varInts = vars.map(function (__x) {
        return ctxSymToIntExn(ctx, __x);
      });
  var maxIdx = varInts.length - 1 | 0;
  for(var i = 0; i <= maxIdx; ++i){
    for(var j = i + 1 | 0; j <= maxIdx; ++j){
      disjAddPair(ctx.contents.disj, varInts[i], varInts[j]);
    }
  }
}

function addFloating(ctx, label, exprStr) {
  if (exprStr.length !== 2) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Length of a floating expression must be 2."
          },
          Error: new Error()
        };
  }
  assertNameIsUnique(ctx, label, "a floating label");
  var typName = exprStr[0];
  var varName = exprStr[1];
  if (!isConst(ctx, typName)) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "The first symbol in the floating '" + typName + "' must be a constant."
          },
          Error: new Error()
        };
  }
  if (!isVar(ctx, varName)) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "The second symbol in the floating '" + varName + "' must be a variable."
          },
          Error: new Error()
        };
  }
  var varInt = ctxSymToIntExn(ctx, varName);
  if (Belt_Option.isSome(getTypeOfVar(ctx, varInt))) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot redefine typecode for the variable '" + varName + "'"
          },
          Error: new Error()
        };
  }
  var typInt = ctxSymToIntExn(ctx, typName);
  var expr = [
    typInt,
    varInt
  ];
  var hyp = {
    typ: "F",
    label: label,
    expr: expr
  };
  var ctx$1 = ctx.contents;
  ctx$1.hyps.push(hyp);
  Belt_HashMapString.set(ctx$1.labelToHyp, label, hyp);
  exprToHypAdd(ctx$1, hyp);
  Belt_HashMapInt.set(ctx$1.varTypes, varInt, typInt);
}

function addEssential(ctx, label, exprStr) {
  if (exprStr.length < 1) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Length of an essential expression must be at least 1."
          },
          Error: new Error()
        };
  }
  if (!isConst(ctx, exprStr[0])) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "The first symbol in an essential expression must be a constant."
          },
          Error: new Error()
        };
  }
  var expr = ctxSymsToIntsExn(ctx, exprStr);
  var hyp = {
    typ: "E",
    label: label,
    expr: expr
  };
  var ctx$1 = ctx.contents;
  ctx$1.hyps.push(hyp);
  Belt_HashMapString.set(ctx$1.labelToHyp, label, hyp);
  exprToHypAdd(ctx$1, hyp);
}

function ctxIntToFrameInt(ctxToFrameRenum, ctxInt) {
  if (ctxInt < 0) {
    return ctxInt;
  }
  var frameInt = Belt_HashMapInt.get(ctxToFrameRenum, ctxInt);
  if (frameInt !== undefined) {
    return frameInt;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot determine frame variable for the context variable " + String(ctxInt) + "."
        },
        Error: new Error()
      };
}

function renumberVarsInExpr(ctxToFrameRenum, expr) {
  return expr.map(function (__x) {
              return ctxIntToFrameInt(ctxToFrameRenum, __x);
            });
}

function renumberVarsInDisj(ctxToFrameRenum, disj) {
  var res = Belt_HashMapInt.make(16);
  disjForEach(disj, (function (n, m) {
          disjAddPair(res, ctxIntToFrameInt(ctxToFrameRenum, n), ctxIntToFrameInt(ctxToFrameRenum, m));
        }));
  return Belt_MapInt.fromArray(Belt_HashMapInt.toArray(res).map(function (param) {
                  return [
                          param[0],
                          Belt_SetInt.fromArray(Belt_HashSetInt.toArray(param[1]))
                        ];
                }));
}

function matchesOptRegex(str, regex) {
  return Belt_Option.getWithDefault(Belt_Option.map(regex, (function (regex) {
                    return regex.test(str);
                  })), false);
}

function isMatch(descr, label, descrRegexToMatch, labelRegexToMatch) {
  if (Belt_Option.getWithDefault(Belt_Option.map(descr, (function (__x) {
                return matchesOptRegex(__x, descrRegexToMatch);
              })), false)) {
    return true;
  } else {
    return matchesOptRegex(label, labelRegexToMatch);
  }
}

function isTranDepr(ctx, proof) {
  if (proof === undefined) {
    return false;
  }
  var labels = proof.labels;
  return Belt_Option.getWithDefault(forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
                    if (labels.some(function (label) {
                            return Belt_HashSetString.has(ctx.deprOrTranDeprFrms, label);
                          })) {
                      return true;
                    }
                    
                  })), false);
}

function getAsrtVarHyps(numOfVars, asrtHyps) {
  var varHyps = Belt_Array.make(numOfVars, -1);
  asrtHyps.forEach(function (hyp, i) {
        if (hyp.typ !== "F") {
          return ;
        }
        var asrtVarNum = hyp.expr[1];
        if (asrtVarNum >= numOfVars) {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Internal error: hyp.expr[1] >= numOfVars"
                },
                Error: new Error()
              };
        }
        varHyps[asrtVarNum] = i;
      });
  if (varHyps.some(function (idx) {
          return idx < 0;
        })) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Internal error: varHyps->Array.some(idx => idx < 0)"
          },
          Error: new Error()
        };
  }
  return varHyps;
}

var normalizeDescrRegex = new RegExp("\\s+", "g");

function normalizeDescr(descr) {
  return descr.trim().toLowerCase().replaceAll(normalizeDescrRegex, " ");
}

function createFrame(ctx, ord, isAxiom, label, exprStr, proof, tokenTypeOpt, skipEssentialsOpt, skipFirstSymCheckOpt, skipDisjOpt, overrideHyps, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr) {
  var tokenType = tokenTypeOpt !== undefined ? tokenTypeOpt : "a frame";
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var skipFirstSymCheck = skipFirstSymCheckOpt !== undefined ? skipFirstSymCheckOpt : false;
  var skipDisj = skipDisjOpt !== undefined ? skipDisjOpt : false;
  assertNameIsUnique(ctx, label, tokenType);
  if (exprStr.length < 1) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Length of an assertion expression must be at least 1."
          },
          Error: new Error()
        };
  }
  if (!skipFirstSymCheck && !isConst(ctx, exprStr[0])) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "The first symbol in an assertion expression must be a constant."
          },
          Error: new Error()
        };
  }
  var sym = exprStr.find(function (sym) {
        return Belt_Option.isNone(ctxSymToInt(ctx, sym));
      });
  if (sym !== undefined) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "The symbol '" + sym + "' must be either a constant or a variable."
          },
          Error: new Error()
        };
  }
  var asrt = exprStr.map(function (__x) {
        return ctxSymToIntExn(ctx, __x);
      });
  var mandatoryVarsSet = extractMandatoryVariables(ctx, asrt, skipEssentials, overrideHyps);
  var mandatoryVarsArr = Belt_HashSetInt.toArray(mandatoryVarsSet);
  var mandatoryDisj = skipDisj ? Belt_HashMapInt.make(16) : extractMandatoryDisj(ctx, mandatoryVarsSet);
  var mandatoryHypotheses = extractMandatoryHypotheses(ctx, mandatoryVarsSet, skipEssentials, overrideHyps);
  var ctxToFrameRenum = Belt_HashMapInt.fromArray(mandatoryVarsArr.map(function (cv, fv) {
            return [
                    cv,
                    fv
                  ];
          }));
  var descr = ctx.contents.lastComment;
  var descrNorm = Core__Option.map(descr, normalizeDescr);
  var hyps = mandatoryHypotheses.map(function (__x) {
        return {
                typ: __x.typ,
                label: __x.label,
                expr: renumberVarsInExpr(ctxToFrameRenum, __x.expr)
              };
      });
  var numOfVars = mandatoryVarsArr.length;
  return {
          ord: ord,
          isAxiom: isAxiom,
          disj: renumberVarsInDisj(ctxToFrameRenum, mandatoryDisj),
          hyps: hyps,
          asrt: renumberVarsInExpr(ctxToFrameRenum, asrt),
          label: label,
          frameVarToSymb: mandatoryVarsArr.map(function (__x) {
                return ctxIntToSymExn(ctx, __x);
              }),
          varTypes: mandatoryVarsArr.map(function (__x) {
                return getTypeOfVarExn(ctx, __x);
              }),
          varHyps: getAsrtVarHyps(numOfVars, hyps),
          numOfVars: numOfVars,
          numOfArgs: mandatoryHypotheses.length,
          descr: descr,
          descrNorm: descrNorm,
          proof: proof,
          isDisc: isMatch(descr, label, descrRegexToDisc, labelRegexToDisc),
          isDepr: isMatch(descr, label, descrRegexToDepr, labelRegexToDepr),
          isTranDepr: isTranDepr(ctx, proof),
          dbg: ctx.contents.debug ? ({
                disj: disjToArr(mandatoryDisj, undefined, undefined, undefined, undefined).map(function (__x) {
                      return ctxIntsToStrExn(ctx, __x);
                    }),
                hyps: mandatoryHypotheses.map(function (hyp) {
                      return ctxIntsToStrExn(ctx, hyp.expr);
                    }),
                asrt: ctxIntsToStrExn(ctx, asrt)
              }) : undefined,
          usageCnt: -1
        };
}

function addAssertion(ctx, isAxiom, label, exprStr, proof, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr) {
  var currCtx = ctx.contents;
  var frame = createFrame(ctx, currCtx.totalNumOfFrames, isAxiom, label, exprStr, proof, Belt_Option.isNone(proof) ? "an axiom" : "a theorem", undefined, undefined, undefined, undefined, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr);
  Belt_HashMapString.set(currCtx.frames, label, frame);
  currCtx.totalNumOfFrames = currCtx.totalNumOfFrames + 1 | 0;
  if (frame.isDepr || frame.isTranDepr) {
    return Belt_HashSetString.add(currCtx.deprOrTranDeprFrms, label);
  }
  
}

function applySingleStmt(ctx, stmt, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr) {
  var isComment = false;
  switch (stmt.TAG) {
    case "Comment" :
        addComment(ctx, stmt.text);
        isComment = true;
        break;
    case "Const" :
        stmt.symbols.forEach(function (__x) {
              if (Belt_Option.isSome(ctx.contents.parent)) {
                throw {
                      RE_EXN_ID: Common.MmException,
                      _1: {
                        msg: "An attempt to declare a constant '" + __x + "' in an inner block."
                      },
                      Error: new Error()
                    };
              }
              assertNameIsUnique(ctx, __x, "a constant");
              var ctx$1 = ctx.contents;
              Belt_HashMapString.set(ctx$1.symToInt, __x, -ctx$1.consts.length | 0);
              ctx$1.consts.push(__x);
            });
        break;
    case "Block" :
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "Block statements are not accepted by applySingleStmt()."
              },
              Error: new Error()
            };
    case "Var" :
        stmt.symbols.forEach(function (__x) {
              assertNameIsUnique(ctx, __x, "a variable");
              var ctx$1 = ctx.contents;
              Belt_HashMapString.set(ctx$1.symToInt, __x, ctx$1.varsBaseIdx + ctx$1.vars.length | 0);
              ctx$1.vars.push(__x);
            });
        break;
    case "Disj" :
        addDisj(ctx, stmt.vars);
        break;
    case "Floating" :
        addFloating(ctx, stmt.label, stmt.expr);
        break;
    case "Essential" :
        addEssential(ctx, stmt.label, stmt.expr);
        break;
    case "Axiom" :
        addAssertion(ctx, true, stmt.label, stmt.expr, undefined, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr);
        break;
    case "Provable" :
        addAssertion(ctx, false, stmt.label, stmt.expr, stmt.proof, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr);
        break;
    
  }
  if (!isComment) {
    ctx.contents.lastComment = undefined;
    return ;
  }
  
}

function loadContext(ast, initialContext, stopBeforeOpt, stopAfterOpt, onPreProcess, expectedNumOfAssertionsOpt, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr, onProgressOpt, debugOpt) {
  var stopBefore = stopBeforeOpt !== undefined ? stopBeforeOpt : "";
  var stopAfter = stopAfterOpt !== undefined ? stopAfterOpt : "";
  var expectedNumOfAssertions = expectedNumOfAssertionsOpt !== undefined ? expectedNumOfAssertionsOpt : -1;
  var onProgress = onProgressOpt !== undefined ? onProgressOpt : (function (param) {
        
      });
  var debug = debugOpt !== undefined ? debugOpt : false;
  var assertionsProcessed = {
    contents: 0
  };
  var progressTracker = MM_progress_tracker.progressTrackerMake(0.1, undefined, onProgress, undefined);
  var onAsrtProcess = function () {
    if (expectedNumOfAssertions > 0) {
      assertionsProcessed.contents = assertionsProcessed.contents + 1;
      return MM_progress_tracker.progressTrackerSetCurrPct(progressTracker, assertionsProcessed.contents / expectedNumOfAssertions);
    }
    
  };
  return MM_parser.traverseAst(initialContext !== undefined ? initialContext : createContext(undefined, debug), ast, (function (ctx, node) {
                  if (onPreProcess !== undefined) {
                    onPreProcess(ctx, node.stmt);
                  }
                  var match = node.stmt;
                  switch (match.TAG) {
                    case "Block" :
                        if (match.level > 0) {
                          openChildContext(ctx);
                        }
                        ctx.contents.lastComment = undefined;
                        return ;
                    case "Axiom" :
                    case "Provable" :
                        break;
                    default:
                      return ;
                  }
                  onAsrtProcess();
                  if (stopBefore === match.label) {
                    return Caml_option.some(undefined);
                  }
                  
                }), (function (ctx, node) {
                  var stmt = node.stmt;
                  if (stmt.TAG !== "Block") {
                    applySingleStmt(ctx, stmt, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr);
                  }
                  
                }), (function (ctx, node) {
                  var match = node.stmt;
                  switch (match.TAG) {
                    case "Block" :
                        if (match.level > 0) {
                          closeChildContext(ctx);
                        }
                        return ;
                    case "Axiom" :
                    case "Provable" :
                        break;
                    default:
                      return ;
                  }
                  if (stopAfter === match.label) {
                    return Caml_option.some(undefined);
                  }
                  
                }))[0];
}

function generateNewVarNames(ctx, types, typeToPrefixOpt, reservedNames) {
  var typeToPrefix = typeToPrefixOpt !== undefined ? Caml_option.valFromOption(typeToPrefixOpt) : undefined;
  var prefixToCnt = Belt_HashMapString.make(Belt_MapString.size(typeToPrefix));
  var getCnt = function (prefix) {
    return Belt_Option.getWithDefault(Belt_HashMapString.get(prefixToCnt, prefix), 0);
  };
  var incCnt = function (prefix) {
    Belt_HashMapString.set(prefixToCnt, prefix, getCnt(prefix) + 1 | 0);
  };
  var maxI = types.length - 1 | 0;
  var res = [];
  for(var i = 0; i <= maxI; ++i){
    var typeStr = ctxIntToSymExn(ctx, types[i]);
    var prefix = Belt_MapString.getWithDefault(typeToPrefix, typeStr, typeStr);
    incCnt(prefix);
    var newName = {
      contents: prefix + String(getCnt(prefix))
    };
    while(Belt_Option.isSome(getTokenType(ctx, newName.contents)) || Belt_Option.getWithDefault(Belt_Option.map(reservedNames, (function(newName){
              return function (__x) {
                return Belt_HashSetString.has(__x, newName.contents);
              }
              }(newName))), false)) {
      incCnt(prefix);
      newName.contents = prefix + String(getCnt(prefix));
    };
    res.push(newName.contents);
  }
  return res;
}

function generateNewLabels(ctx, prefix, amount, reservedLabels, checkHypsOnlyOpt) {
  var checkHypsOnly = checkHypsOnlyOpt !== undefined ? checkHypsOnlyOpt : false;
  var labelIsReserved = function (label) {
    if (Belt_Option.getWithDefault(Belt_Option.map(reservedLabels, (function (__x) {
                  return Belt_HashSetString.has(__x, label);
                })), false) || !checkHypsOnly && Belt_Option.isSome(getTokenType(ctx, label))) {
      return true;
    } else if (checkHypsOnly) {
      return isHyp(ctx, label);
    } else {
      return false;
    }
  };
  var maxI = amount - 1 | 0;
  var cnt = 0;
  var res = [];
  for(var _for = 0; _for <= maxI; ++_for){
    cnt = cnt + 1 | 0;
    var newName = prefix + String(cnt);
    while(labelIsReserved(newName)) {
      cnt = cnt + 1 | 0;
      newName = prefix + String(cnt);
    };
    res.push(newName);
  }
  return res;
}

function renumberConst(constRenum, c) {
  return Belt_Option.getWithDefault(Belt_HashMapInt.get(constRenum, c), c);
}

function renumberConstsInExpr(constRenum, expr) {
  var maxI = expr.length - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var sym = expr[i];
    if (sym < 0) {
      expr[i] = renumberConst(constRenum, sym);
    }
    
  }
}

function moveConstsToBegin(ctx, firstConsts) {
  var rootCtx = Belt_Option.getExn(ctx.contents.root);
  var newConstOrder = firstConsts.slice();
  for(var i = -1 ,i_finish = -(rootCtx.consts.length - 1 | 0) | 0; i >= i_finish; --i){
    if (!newConstOrder.includes(i)) {
      newConstOrder.push(i);
    }
    
  }
  var oldConstOrder = rootCtx.consts.slice();
  var constRenum = Belt_HashMapInt.make(rootCtx.consts.length);
  newConstOrder.forEach(function (symOldInt, i) {
        var sym = oldConstOrder[-symOldInt | 0];
        var symNewInt = -(i + 1 | 0) | 0;
        Belt_HashMapInt.set(constRenum, symOldInt, symNewInt);
        rootCtx.consts[-symNewInt | 0] = sym;
        Belt_HashMapString.set(rootCtx.symToInt, sym, symNewInt);
      });
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          renumberConstsInExpr(constRenum, hyp.expr);
        }));
  forEachFrame(ctx, (function (frame) {
          frame.hyps.forEach(function (hyp) {
                renumberConstsInExpr(constRenum, hyp.expr);
              });
          renumberConstsInExpr(constRenum, frame.asrt);
          renumberConstsInExpr(constRenum, frame.varTypes);
        }));
  forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
          var maxI = ctx.vars.length - 1 | 0;
          for(var i = 0; i <= maxI; ++i){
            var $$var = ctx.varsBaseIdx + i | 0;
            var oldTyp = Belt_HashMapInt.get(ctx.varTypes, $$var);
            if (oldTyp !== undefined) {
              Belt_HashMapInt.set(ctx.varTypes, $$var, renumberConst(constRenum, oldTyp));
            }
            
          }
          Belt_HashMapInt.clear(ctx.exprToHyp);
          ctx.hyps.forEach(function (__x) {
                exprToHypAdd(ctx, __x);
              });
        }));
}

function frameUpdate(frame, removeAsrtDescr, removeProofs, frmUsageCounts) {
  var cnt = Belt_HashMapString.get(frmUsageCounts, frame.label);
  var usageCnt = cnt !== undefined ? cnt.contents : frame.usageCnt;
  return {
          ord: frame.ord,
          isAxiom: frame.isAxiom,
          disj: frame.disj,
          hyps: frame.hyps,
          asrt: frame.asrt,
          label: frame.label,
          frameVarToSymb: frame.frameVarToSymb,
          varTypes: frame.varTypes,
          varHyps: frame.varHyps,
          numOfVars: frame.numOfVars,
          numOfArgs: frame.numOfArgs,
          descr: removeAsrtDescr ? undefined : frame.descr,
          descrNorm: removeAsrtDescr ? undefined : frame.descrNorm,
          proof: removeProofs ? undefined : frame.proof,
          isDisc: frame.isDisc,
          isDepr: frame.isDepr,
          isTranDepr: frame.isTranDepr,
          dbg: frame.dbg,
          usageCnt: usageCnt
        };
}

function ctxUpdate(ctx, removeAsrtDescr, removeProofs, frmUsageCounts) {
  var update = function (ctx) {
    var parent = ctx.parent;
    return {
            root: ctx.root,
            parent: ctx.parent,
            consts: ctx.consts,
            varsBaseIdx: ctx.varsBaseIdx,
            vars: ctx.vars,
            symToInt: ctx.symToInt,
            disj: ctx.disj,
            hyps: ctx.hyps,
            labelToHyp: ctx.labelToHyp,
            exprToHyp: ctx.exprToHyp,
            varTypes: ctx.varTypes,
            lastComment: removeAsrtDescr ? undefined : ctx.lastComment,
            frames: Belt_HashMapString.fromArray(Belt_HashMapString.toArray(ctx.frames).map(function (param) {
                      return [
                              param[0],
                              frameUpdate(param[1], removeAsrtDescr, removeProofs, frmUsageCounts)
                            ];
                    })),
            totalNumOfFrames: parent !== undefined ? parent.totalNumOfFrames + Belt_HashMapString.size(ctx.frames) | 0 : Belt_HashMapString.size(ctx.frames),
            deprOrTranDeprFrms: Belt_HashSetString.make(0),
            debug: ctx.debug
          };
  };
  var parent = ctx.parent;
  if (parent !== undefined) {
    var match = ctxUpdate(parent, removeAsrtDescr, removeProofs, frmUsageCounts);
    var newRoot = match[0];
    var init = update(ctx);
    var res = {
      root: newRoot,
      parent: match[1],
      consts: init.consts,
      varsBaseIdx: init.varsBaseIdx,
      vars: init.vars,
      symToInt: init.symToInt,
      disj: init.disj,
      hyps: init.hyps,
      labelToHyp: init.labelToHyp,
      exprToHyp: init.exprToHyp,
      varTypes: init.varTypes,
      lastComment: init.lastComment,
      frames: init.frames,
      totalNumOfFrames: init.totalNumOfFrames,
      deprOrTranDeprFrms: init.deprOrTranDeprFrms,
      debug: init.debug
    };
    return [
            newRoot,
            res
          ];
  }
  var res$1 = update(ctx);
  res$1.root = res$1;
  return [
          res$1,
          res$1
        ];
}

function sortBySym(ctx, expr) {
  var __x = ctxIntsToSymsExn(ctx, expr).sort();
  return ctxSymsToIntsExn(ctx, __x);
}

function ctxGetOptimizedConstsOrder(ctx, parens) {
  var allConsts = Belt_HashSetInt.fromArray(ctxSymsToIntsExn(ctx, getAllConsts(ctx)));
  var numOfConsts = Belt_HashSetInt.size(allConsts);
  var canBeFirst = Belt_HashSetInt.make(numOfConsts);
  var canBeLast = Belt_HashSetInt.make(numOfConsts);
  forEachFrame(ctx, (function (frame) {
          var first = frame.asrt[1];
          if (first < 0) {
            Belt_HashSetInt.add(canBeFirst, first);
          }
          var last = frame.asrt[frame.asrt.length - 1 | 0];
          if (last < 0) {
            Belt_HashSetInt.add(canBeLast, last);
          }
          
        }));
  var canBeFirstAndLast = Belt_HashSetInt.fromArray(Belt_HashSetInt.toArray(canBeFirst).filter(function (__x) {
            return Belt_HashSetInt.has(canBeLast, __x);
          }));
  Belt_HashSetInt.forEach(canBeFirstAndLast, (function (param) {
          return Belt_HashSetInt.remove(canBeFirst, param);
        }));
  Belt_HashSetInt.forEach(canBeFirstAndLast, (function (param) {
          return Belt_HashSetInt.remove(canBeLast, param);
        }));
  var parenInts = Common.getSpaceSeparatedValuesAsArray(parens).map(function (__x) {
            return ctxSymToInt(ctx, __x);
          }).filter(function (intOpt) {
          return Belt_Option.mapWithDefault(intOpt, false, (function (i) {
                        return i < 0;
                      }));
        }).map(Belt_Option.getExn);
  parenInts.forEach(function (i) {
        Belt_HashSetInt.remove(canBeFirst, i);
        Belt_HashSetInt.remove(canBeFirstAndLast, i);
        Belt_HashSetInt.remove(canBeLast, i);
      });
  var remainingConsts = Belt_HashSetInt.fromArray(Belt_HashSetInt.toArray(allConsts).filter(function (i) {
            if (!parenInts.includes(i) && !Belt_HashSetInt.has(canBeFirst, i) && !Belt_HashSetInt.has(canBeFirstAndLast, i)) {
              return !Belt_HashSetInt.has(canBeLast, i);
            } else {
              return false;
            }
          }));
  var newConstsOrder = Belt_Array.concatMany([
        parenInts,
        (function (__x) {
              return sortBySym(ctx, __x);
            })(Belt_HashSetInt.toArray(canBeFirst)),
        (function (__x) {
              return sortBySym(ctx, __x);
            })(Belt_HashSetInt.toArray(canBeFirstAndLast)),
        (function (__x) {
              return sortBySym(ctx, __x);
            })(Belt_HashSetInt.toArray(canBeLast)),
        (function (__x) {
              return sortBySym(ctx, __x);
            })(Belt_HashSetInt.toArray(remainingConsts))
      ]);
  var parenMin = -parenInts.length | 0;
  var canBeFirstMax = parenMin - 1 | 0;
  var canBeFirstMin = (canBeFirstMax - Belt_HashSetInt.size(canBeFirst) | 0) + 1 | 0;
  var canBeFirstAndLastMax = canBeFirstMin - 1 | 0;
  var canBeFirstAndLastMin = (canBeFirstAndLastMax - Belt_HashSetInt.size(canBeFirstAndLast) | 0) + 1 | 0;
  var canBeLastMax = canBeFirstAndLastMin - 1 | 0;
  var canBeLastMin = (canBeLastMax - Belt_HashSetInt.size(canBeLast) | 0) + 1 | 0;
  return {
          allConsts: ctxIntsToSymsExn(ctx, newConstsOrder),
          parenMin: parenMin,
          canBeFirstMin: canBeFirstAndLastMin,
          canBeFirstMax: canBeFirstMax,
          canBeLastMin: canBeLastMin,
          canBeLastMax: canBeFirstAndLastMax
        };
}

function ctxOptimizeForProver(ctx, parens, removeAsrtDescr, removeProofs, updateUsageCntForFrames) {
  var frmUsageCounts;
  if (updateUsageCntForFrames) {
    var allFrms = getAllFramesArr(ctx);
    var cnts = Belt_HashMapString.fromArray(allFrms.map(function (frm) {
              return [
                      frm.label,
                      {
                        contents: 0
                      }
                    ];
            }));
    allFrms.forEach(function (frm) {
          var match = frm.proof;
          if (match !== undefined) {
            return Belt_HashSetString.forEach(Belt_HashSetString.fromArray(match.labels), (function (label) {
                          var cnt = Belt_HashMapString.get(cnts, label);
                          if (cnt !== undefined) {
                            cnt.contents = cnt.contents + 1 | 0;
                            return ;
                          }
                          
                        }));
          }
          
        });
    frmUsageCounts = cnts;
  } else {
    frmUsageCounts = Belt_HashMapString.make(0);
  }
  var match = ctxUpdate(ctx.contents, removeAsrtDescr, removeProofs, frmUsageCounts);
  var resCtx = {
    contents: match[1]
  };
  var match$1 = ctxGetOptimizedConstsOrder(resCtx, parens);
  moveConstsToBegin(resCtx, ctxSymsToIntsExn(resCtx, match$1.allConsts));
  return resCtx;
}

exports.createContext = createContext;
exports.applySingleStmt = applySingleStmt;
exports.openChildContext = openChildContext;
exports.closeChildContext = closeChildContext;
exports.resetToParentContext = resetToParentContext;
exports.loadContext = loadContext;
exports.ctxOptimizeForProver = ctxOptimizeForProver;
exports.ctxGetOptimizedConstsOrder = ctxGetOptimizedConstsOrder;
exports.isDebug = isDebug;
exports.isConst = isConst;
exports.isVar = isVar;
exports.isHyp = isHyp;
exports.isAsrt = isAsrt;
exports.isDisj = isDisj;
exports.getAllConsts = getAllConsts;
exports.getHypothesis = getHypothesis;
exports.getHypByExpr = getHypByExpr;
exports.getMandHyps = getMandHyps;
exports.getAllHyps = getAllHyps;
exports.getAllFrames = getAllFrames;
exports.getAllFramesArr = getAllFramesArr;
exports.getAllDisj = getAllDisj;
exports.getLocalDisj = getLocalDisj;
exports.getFrame = getFrame;
exports.getFrameExn = getFrameExn;
exports.frameIsAllowed = frameIsAllowed;
exports.getLocalVars = getLocalVars;
exports.getLocalHyps = getLocalHyps;
exports.getNumOfVars = getNumOfVars;
exports.forEachFrame = forEachFrame;
exports.forEachHypothesisInDeclarationOrder = forEachHypothesisInDeclarationOrder;
exports.getNestingLevel = getNestingLevel;
exports.findParentheses = findParentheses;
exports.getTypeOfVar = getTypeOfVar;
exports.getTypeOfVarExn = getTypeOfVarExn;
exports.getTokenType = getTokenType;
exports.ctxSymToInt = ctxSymToInt;
exports.ctxIntToSym = ctxIntToSym;
exports.ctxSymToIntExn = ctxSymToIntExn;
exports.ctxSymsToIntsExn = ctxSymsToIntsExn;
exports.ctxStrToIntsExn = ctxStrToIntsExn;
exports.ctxIntToSymExn = ctxIntToSymExn;
exports.ctxIntsToSymsExn = ctxIntsToSymsExn;
exports.ctxIntsToStrExn = ctxIntsToStrExn;
exports.frmIntToSym = frmIntToSym;
exports.frmIntToSymExn = frmIntToSymExn;
exports.frmIntsToStrExn = frmIntsToStrExn;
exports.frmIntsToSymsExn = frmIntsToSymsExn;
exports.createFrame = createFrame;
exports.generateNewVarNames = generateNewVarNames;
exports.generateNewLabels = generateNewLabels;
exports.disjMake = disjMake;
exports.disjAddPair = disjAddPair;
exports.disjContains = disjContains;
exports.disjImmContains = disjImmContains;
exports.disjToArr = disjToArr;
exports.disjForEachArr = disjForEachArr;
exports.disjForEach = disjForEach;
exports.disjImmForEach = disjImmForEach;
exports.disjIsEmpty = disjIsEmpty;
exports.disjMutToDisjImm = disjMutToDisjImm;
exports.disjGetAllVars = disjGetAllVars;
exports.disjToStrDbg = disjToStrDbg;
exports.exprEq = exprEq;
exports.ExprCmp = ExprCmp;
exports.ExprHash = ExprHash;
exports.normalizeDescr = normalizeDescr;
/* ExprCmp Not a pure module */
